import { useMutation, useQueryClient } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { CreateExerciseInput } from '../types';

import { exercisesKeys } from './useExercises';

export function useCreateExercise() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateExerciseInput) => exercisesService.create(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: exercisesKeys.lists() });
    },
  });
}
